import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=641f12aa&scoped=true&"
import script from "./appointment.vue?vue&type=script&lang=js&"
export * from "./appointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f12aa",
  null
  
)

export default component.exports